var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"china-map",attrs:{"id":_vm.mId}})
}
var staticRenderFns = []

export { render, staticRenderFns }